import forage from 'localforage'

export const fTable = forage.createInstance({
  name: 'crms-table',
  storeName: 'asm',
  driver: [
    forage.INDEXEDDB,
    forage.LOCALSTORAGE
  ]
})

const setTableOptions = ({ currentPage, perPage, sortBy, sortDesc, filter, totalRows }) => {
  return fTable.setItem('r-officer-tasks', {
    currentPage,
    perPage,
    sortBy,
    sortDesc,
    totalRows,
    filter: {
      search: filter.search,
      month: filter.month,
      officer: filter.officer
    }
  })
}

const getTableOptions = async () => {
  return await fTable.getItem('r-officer-tasks')
}

export {
  setTableOptions,
  getTableOptions
}
